export const GET_SHORTS="GET_SHORTS"
export const IMPORT_SHORT="IMPORT_SHORT"
export const EDIT_SHORT="EDIT_SHORT"
export const DELETE_SHORT="DELETE_SHORT"
export const GET_SHORT_STATS_DATA = "GET_SHORT_STATS_DATA"
